import React, { useState, Fragment } from "react";
import { Box } from "@mui/material";
import BasicButton from "components/v2/common/BasicButton";
import LikeActiveIcon from "@mui/icons-material/Favorite";
import LikeInactiveIcon from "@mui/icons-material/FavoriteBorder";
import { dispatcherActions } from "_actions";
import { useDispatch } from "react-redux";
import { buildHidePayload } from "components/v2/views/Vote/Utilities/VoteUtils";
import _ from "lodash";
import { getProfileUrl } from "./inboxUtils";

export default function ReactionEntry({ conversation, sourceName }) {
  const dispatch = useDispatch();
  const canBeLiked = _.get(conversation, "canBeLiked"); 
  const canBeHidden = _.get(conversation, "canBeHidden");
  const hiddenFromSource = _.get(conversation, "hiddenFromSource");
  const canBeDeletedFromSource = _.get(conversation, "canBeDeletedFromSource");
  const removedFromSource = _.get(conversation, "removedFromSource");
  
  const [isLiked, setIsLiked] = useState(false);
  const [isHidden, setIsHidden] = useState(Boolean(hiddenFromSource));
  const [isDeleted, setIsDeleted] = useState(Boolean(removedFromSource));
  const messageId = _.get(conversation, "id");
  const profileUrl = getProfileUrl(conversation, sourceName);

  const handleLike = () => {
    setIsLiked(true);
    if (!isLiked) {
      dispatch(dispatcherActions.likeMessageFromSource(messageId, sourceName));
    }
  };

  const handleHide = () => {
    const payload = buildHidePayload(conversation, !isHidden);
    setIsHidden(!isHidden);
    dispatch(dispatcherActions.updateMessageFromSource(messageId, payload));
  };

  const handleViewProfile = () => {
    if (profileUrl) {
      window.open(profileUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleDelete = () => {
    if (isDeleted || !messageId) {
      return;
    }

    setIsDeleted(true);
    dispatch(
      dispatcherActions.deleteMessageFromSource(messageId, {
        isV2Enabled: _.get(conversation, "isV2Enabled"),
        source: sourceName || _.get(conversation, "sourceName"),
      }),
    );
  };

  const showActions = canBeLiked || canBeHidden || profileUrl || canBeDeletedFromSource;

  if(!showActions) return <Fragment/>

  return (
    <Box sx={styles.wrapper}>
      {canBeLiked && (
        <BasicButton
          startIcon={
            isLiked ? (
              <LikeActiveIcon style={{ fontSize: "16px" }} />
            ) : (
              <LikeInactiveIcon style={{ fontSize: "16px" }} />
            )
          }
          style={styles.outlineBtn}
          label={"Like"}
          action={handleLike}
        />
      )}

      {profileUrl && (
        <BasicButton
          style={styles.outlineBtn}
          label={"View profile"}
          action={handleViewProfile}
        />
      )}

      {canBeHidden && (
        <BasicButton
          style={{ ...styles.outlineBtn, ...styles.errorBtn }}
          label={isHidden ? "Unhide" : "Hide"}
          action={handleHide}
        />
      )}

      {canBeDeletedFromSource && (
        <BasicButton
          style={{ ...styles.outlineBtn, ...styles.errorBtn }}
          label={"Delete"}
          action={handleDelete}
          disabled={isDeleted}
        />
      )}
    </Box>
  );
}


const styles = {
  wrapper: { 
    display: "flex", 
    alignItems: "center",
    gap: "10px", 
    mt: 2,
   },
  outlineBtn: {
    fontSize: "12px",
    padding: "8px 13px",
    borderRadius: "9px",
    border: "1px solid #d9d3c9",
    backgroundColor: "#ffffff",
    width: "max-content",
    color: "#33413a",
    ":hover": {
      backgroundColor: "#ffffff",
      color: "#002900",
    },
  },
  errorBtn: {
    color: "#c0392b",
    border: "1px solid #eecfba",
  },
};
